"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMediaQuery = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

/* There would be no window.matchMedia in test environment because jsdom
 * hasn't implemented it yet. We handle this case in UI Kit so we don't have
 * to add mocks for matchMedia to every project.
 */
function matchMedia(query) {
  if (typeof window === 'undefined') {
    return {
      matches: false
    };
  }

  if ('matchMedia' in window) {
    return window.matchMedia(query);
  }

  return {
    matches: false
  };
}

var useMediaQuery = function useMediaQuery(query) {
  var cleanQuery = query.replace(/^\s*@media\s*/, '');
  var matcher = (0, _react.useMemo)(function () {
    return matchMedia(cleanQuery);
  }, [cleanQuery]);

  var _useState = (0, _react.useState)(matcher.matches),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      return setMatches(event.matches);
    };

    if ('addEventListener' in matcher) {
      matcher.addEventListener('change', listener);
      return function () {
        matcher.removeEventListener('change', listener);
      };
    }

    if ('addListener' in matcher) {
      // IE 11 fallback
      matcher.addListener(listener);
      return function () {
        matcher.removeListener(listener);
      };
    }

    return undefined;
  }, [matcher]);
  return (0, _react.useMemo)(function () {
    return {
      matches: matches
    };
  }, [matches]);
};

exports.useMediaQuery = useMediaQuery;